import { render, staticRenderFns } from "./CollectionBackPerformanceForAmount2.vue?vue&type=template&id=749170c0&scoped=true"
import script from "./CollectionBackPerformanceForAmount2.vue?vue&type=script&lang=js"
export * from "./CollectionBackPerformanceForAmount2.vue?vue&type=script&lang=js"
import style0 from "./CollectionBackPerformanceForAmount2.vue?vue&type=style&index=0&id=749170c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749170c0",
  null
  
)

export default component.exports